/**
 * Default assessment from class kind — keeps blind/sight/ear/pedal kind-perfect
 * even when curriculum rows omit an explicit assessment field.
 */
import type { AssessmentMode, ClassKind, TutorClass } from "./types.js";

export function assessmentForKind(kind: ClassKind): AssessmentMode {
  switch (kind) {
    case "blind":
      return "blind";
    case "sight":
      return "sight";
    case "ear":
      return "ear";
    case "pedal":
      return "pedal";
    case "performance":
    case "repertoire":
      return "recital";
    case "speed":
      return "timed";
    default:
      return "guided";
  }
}

/** Fill missing assessment from kind; never override an explicit value. */
export function resolveClassAssessment(tutorClass: TutorClass): AssessmentMode {
  return tutorClass.assessment ?? assessmentForKind(tutorClass.kind);
}

export function normalizeTutorClass(tutorClass: TutorClass): TutorClass {
  if (tutorClass.assessment) return tutorClass;
  return { ...tutorClass, assessment: assessmentForKind(tutorClass.kind) };
}
